var styles = {"container":"styles_container__OTm_I flex","image":"styles_image__1BpoW","content":"styles_content__eoziY absolute"};

export default styles;
//# sourceMappingURL=styles.css.js.map
